import { Hero } from "@/components/Hero";
import { PageLayout } from "@/components/PageLayout";
import { HomeMenuAccordion } from "@/components/HomeMenuAccordion";

const Home = () => (
  <PageLayout testId="home-page">
    <Hero />
    <HomeMenuAccordion />
  </PageLayout>
);

export default Home;
